<template>
	<van-popup
		:show="show"
		@update:show="(val) => $emit('update:show', val)"
		teleport="body"
		position="bottom"
		closeable
		lock-scroll
		safe-area-inset-bottom
		:style="{ height: '90vh' }"
	>
		<listen-scroll class="scroll" :listen="show" @scroll-end="scrollEnd">
			<van-tabs
				swipe-threshold="3"
				scrollspy
				title-active-color="#ff6600"
				color="#ff6600"
				:before-change="() => true"
				@change="onTabsChange"
				class="tabs"
				ref="tabs"
			>
				<van-tab v-for="agree in agrees" :title="agree.name" :name="agree.name">
					<div class="tab-title">{{ agree.name }}</div>
					<div class="com-rich-text" v-html="agree.content"></div>
				</van-tab>
			</van-tabs>
		</listen-scroll>
		<div class="button-box" @click="maunlEnd">
			<div class="button">我已逐页阅读上述内容并同意</div>
		</div>
	</van-popup>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			required: true
		},
		agrees: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			readedPages: new Set(),
			toEnded: false
		}
	},
	watch: {
		show: {
			handler(val) {
				if (val) {
					setTimeout(() => {
						this.listen = true
					}, 400)
				}
			},
			immediate: true
		}
	},
	computed: {},
	mounted() {},
	methods: {
		onTabsChange(name, title) {
			console.log(title)
			this.readedPages.add(title)
			this.checkReaded()
		},
		scrollEnd() {
			this.toEnded = true
			this.checkReaded()
		},
		checkReaded() {
			if (this.toEnded && this.readedPages.size == this.agrees.length) {
				this.$emit('read-end')
			}
		},

		scrollTo(name) {
			this.$refs.tabs.scrollTo(name)
		},

		// 手动完成
		maunlEnd() {
			this.$emit('update:show', false)
			this.$emit('read-end')
		}
	},
	components: {}
}
</script>

<style lang="scss" scoped="scoped">
.scroll {
	position: relative;
	height: calc(100% - 130px);
}

.tabs ::v-deep {
	.van-tabs__wrap {
		position: sticky;
		top: 0;
		z-index: 999;
	}
}

.child-tabs ::v-deep {
	.van-tabs__wrap {
		position: sticky;
		top: var(--van-tabs-line-height);
		z-index: 998;
	}
}
.tab-title {
	line-height: 200px;
	font-size: $font_medium;
	color: #999;
	text-align: center;
}
.tab-sub-title {
	color: $color_main;
	font-size: $font_medium;
	padding: $space_1 $space_2;
	background: #fff;
	position: sticky;
	top: var(--van-tabs-line-height);
	z-index: 2;
}
::v-deep {
	.van-tab__panel {
		&:not(:last-child) {
			border-bottom: 1px solid #999;
		}
	}
}

.button-box {
	padding: $space_2 $space_3;
	.button {
		border-radius: 99px;
		background-color: $color_main;
		color: #fff;
		text-align: center;
		line-height: 2.65;
		font-size: $font_medium_x;
		font-weight: 600;
		box-shadow: 0 0 20px $color_main;
	}
}
</style>
